import React, { useEffect, useRef, useState } from "react";
import { IoStar } from "react-icons/io5";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import { useDispatch, useSelector } from "react-redux";
import { addVenue, removeVenue } from "../Redux/selectedVenuesSlice";
import productimage from "../../../assets/product.png";
import { updateData } from "../Redux/formSlice";
import Submit from "./Submit";
import LoadingSpinner from "../../compontents/LoadingSpinner";

export default function ServicesProvider({ data, description, ProcessingData }) {
  const tabs = ["Venue", "Catering", "Activity", "Other"];
  const tabsRef = useRef([]);
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("Venue");
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [tabUnderlineWidth, setTabUnderlineWidth] = useState(0);
  const [tabUnderlineLeft, setTabUnderlineLeft] = useState(0);

  useEffect(() => {
    if (activeTabIndex === null) {
      return;
    }

    const setTabPosition = () => {
      const currentTab = tabsRef.current[activeTabIndex];
      setTabUnderlineLeft(currentTab?.offsetLeft || 0);
      setTabUnderlineWidth(currentTab?.clientWidth || 0);
    };

    setTabPosition();
  }, [activeTabIndex]);
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveTab((prev) => {
        const currentIndex = tabs.indexOf(prev);
        const nextIndex = (currentIndex + 1) % tabs.length;
        setActiveTabIndex(nextIndex);
        return tabs[nextIndex];
      });
    }, 100000);
    return () => clearInterval(interval);
  }, [tabs]);

  const selectedVenues = useSelector(
    (state) => state.selectedVenues.selectedVenues
  );
  const updatedFormData = useSelector(
    (state) => state.GoogleData.updatedFormData
  );

  const firstItem = updatedFormData[0];
  console.log("firstItem", firstItem)
  const priceText = {
    1: 1000,  // Budget-friendly place
    2: 3000,  // Mid-range place with good value
    3: 7000,  // Higher-end place
    4: 15000, // Luxury and premium option
  };


  // const filteredServices = firstItem?.filter(
  //   (service) =>
  //     service.services_provider_categries?.toLowerCase() ===
  //     activeTab.toLowerCase()
  // );

  const handleCheckboxChange = (venue) => {
    const isVenueSelected = selectedVenues.some(
      (selected) => selected.place_id === venue.place_id
    );
    if (isVenueSelected) {
      dispatch(removeVenue(venue.place_id));
    } else {
      dispatch(addVenue(venue));
    }
  };

  // const getPhotoUrls = (photos) => {
  //   if (photos && photos.length > 0) {
  //     return photos.map((photo) => photo.getUrl({ maxWidth: 400 })); // Return array of photo URLs
  //   }
  //   return []; // Return empty array if no photos are available
  // };
  const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  const getPhotoUrls = (photos) => {
    if (!Array.isArray(photos) || photos.length === 0) {
      return []; // Return an empty array if photos are missing
    }

    return photos.map((photo) => {
      console.log("photos", photos)
      if (photo?.photo_reference) {
        return `https://maps.googleapis.com/maps/api/place/photo?maxwidth=400&photoreference=${photo.photo_reference}&key=${API_KEY}`;
      }
      return null;
    }).filter(Boolean); // Remove any null values
  };


  // Filter categories where providers count is 10 or more
  const filteredCategories = firstItem
    ?.filter(item => item.providers)
    ?.map(item => item.category);

  console.log("filteredCategories", filteredCategories)
  // Final tabs list
  const categories = tabs?.filter(category => filteredCategories?.includes(category));

  console.log("categories", categories);

  const categoryData = categories.map(category => {
    const matchedCategory = firstItem.find(item => item.category === category);

    if (matchedCategory) {
      return {
        category: category,
        providers: matchedCategory.providers.length
          ? matchedCategory.providers
          : [...matchedCategory.providers, ...Array(10 - matchedCategory.providers.length).fill(null)]
      };
    } else {
      return {
        category: category,
        providers: Array(10).fill(null)
      };
    }
  });

  console.log(categoryData);
  const filteredCategoryData = categoryData.find(item => item.category === activeTab);


  return (
    <>
      <div className="w-[96%] max-w-[1230px] m-auto mt-[60px] md:mt-[60px] lg:mt-[40px]">
        <h2
          id="services_provider"
          className="mb-[30px] px-[15px] font-manrope font-[700] text-[25px] leading-[30px] sm:text-[30px] sm:leading-[30px] md:text-[38px] md:leading-[40px] lg:text-[48px] lg:leading-[60px] text-white text-center"
        >
          Select your service providers
        </h2>
        <div className="relative mx-auto flex flex-col items-center">
          <div className="flex-row w-[96%] mb-[40px] max-w-[520px] relative mx-auto flex h-[44px] md:h-[62px] lg:h-[63px] border border-black/40 bg-neutral-800 px-1 backdrop-blur-sm rounded-[60px]">
            <span
              className="absolute bottom-0 top-0 -z-10 flex overflow-hidden rounded-[60px] py-1 transition-all duration-300"
              style={{ left: tabUnderlineLeft, width: tabUnderlineWidth }}
            >
              <span className="h-full w-full rounded-3xl bg-[#4400c3] border-[#4400c3]" />
            </span>
            {tabs.map((tab, index) => {
              const isActive = activeTabIndex === index;

              return (
                <button
                  key={index}
                  ref={(el) => (tabsRef.current[index] = el)}
                  className={`${isActive
                    ? "text-[#ffff]"
                    : "text-[#ffffff8f] hover:text-white"
                    } flex-1 capitalize px-[5px] sm:px-[12px] md:px-[15px] text-[14px] md:text-[15px] lg:text-lg font-semibold rounded-[60px]`}
                  onClick={() => {
                    setActiveTabIndex(index);
                    setActiveTab(tab);
                  }}
                >
                  {tab}
                </button>
              );
            })}
          </div>
        </div>

        <>
          {ProcessingData ? (
            <LoadingSpinner />
          ) : (
            <>
              {filteredCategoryData && filteredCategoryData?.providers?.length > 0 ? (
                <>
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {filteredCategoryData.providers
                      ?.filter(venue => venue !== null) // ✅ Remove null values
                      .map((venue, index) => (
                        <div
                          className={`bg-[#1B1B1B] shadow-md rounded-lg m-2 flex flex-col ${selectedVenues.some(selected => selected.place_id === venue.place_id)
                            ? "border-2 border-[#D7F23F]"
                            : "border-2 border-transparent"
                            }`}
                          key={index}
                        >
                          {/* Venue Card Content */}
                          <div className="relative">
                            {/* Checkbox */}
                            <div className="absolute left-[15px] top-[15px] zindex">
                              <div className="form-checkbx">
                                <input
                                  type="checkbox"
                                  id={`estimate-${index}`}
                                  checked={selectedVenues.some(selected => selected.place_id === venue.place_id)}
                                  onChange={() => handleCheckboxChange(venue)}
                                />
                                <label htmlFor={`estimate-${index}`}></label>
                              </div>
                            </div>

                            {/* Rating */}
                            <div className="absolute right-[8px] top-[8px] z-[50] flex items-center gap-[10px] h-[38px] text-white bg-[#000] rounded-[60px] px-[15px] py-[2px] text-[14px] leading-[15px]">
                              <IoStar size={17} className="text-[#FCD53F]" />
                              {venue?.rating}
                            </div>

                            {/* Price Level */}
                            {venue?.priceLevel && (
                              <div className="estimated-div-color items-end flex justify-between absolute bottom-0 w-full text-white z-10 px-[15px] py-2 text-[15px] md:text-[16px] xl:text-[18px]">
                                <span className="text-[#EB3465] text-[12px]">
                                  Estimated Budget
                                </span>
                                {priceText[venue?.priceLevel] || "1500"}
                              </div>
                            )}

                            {/* Swiper */}
                            <div className="mk relative">
                              <Swiper
                                cssMode={true}
                                navigation={false}
                                pagination={{ clickable: true }}
                                mousewheel={true}
                                keyboard={true}
                                autoplay={{ delay: 3000, disableOnInteraction: false }}
                                modules={[Pagination, Autoplay]}
                                className="mySwiper relative"
                              >
                                {venue?.photos ? (
                                  venue.photos.map((url, imgIndex) => (
                                    <SwiperSlide key={imgIndex}>
                                      <img
                                        src={url ? url : productimage || productimage}
                                        alt={venue?.name}
                                        className="h-[300px] w-full object-cover rounded-t-lg"
                                      />
                                    </SwiperSlide>
                                  ))
                                ) : (
                                  <img
                                    src={productimage}
                                    alt="event"
                                    className="h-[300px] w-full object-cover"
                                  />
                                )}
                              </Swiper>
                            </div>
                          </div>

                          {/* Venue Details */}
                          <div className="p-[15px]" onClick={() => handleCheckboxChange(venue)}>
                            <h2 className="mt-[15px] mb-[15px] text-[18px] capitalize font-semibold text-white">
                              {venue?.name}
                            </h2>
                            <p className="mt-[15px] mb-[15px] text-[15px] capitalize font-normal text-white">
                              {venue?.description}
                            </p>
                            <p className="mt-[15px] mb-[15px] text-[15px] capitalize font-normal text-white">
                              <strong className="text-[#EB3465]">Address:  </strong> {venue?.address}
                            </p>

                            <div className="mt-[15px] mb-[15px] text-[15px] capitalize font-normal text-white flex items-center gap-6 flex-wrap">
                              <p>
                                <strong className="text-[#EB3465]">Review:</strong> {venue?.reviews || "No Reviews"}
                              </p>

                              {venue?.directions ? (
                                <p>
                                  <strong className="text-[#EB3465]">Direction:</strong>
                                  <a
                                    href={venue.directions}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-400 underline ml-1 hover:text-blue-600"
                                  >
                                    Open in Maps
                                  </a>
                                </p>
                              ) : (
                                <p>       No Direction</p>
                              )}

                              {venue?.phone ? (
                                <p>
                                  <strong className="text-[#EB3465]">Phone:</strong>
                                  <a
                                    href={`tel:${venue.phone}`}
                                    className="text-blue-400 underline ml-1 hover:text-blue-600"
                                  >
                                    {venue.phone}
                                  </a>
                                </p>
                              ) : (
                                <p>No Phone</p>
                              )}

                              {venue?.website ? (
                                <p>
                                  <strong className="text-[#EB3465]">Website:</strong>
                                  <a
                                    href={venue.website}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-400 underline ml-1 hover:text-blue-600"
                                  >
                                    Visit Website
                                  </a>
                                </p>
                              ) : (
                                <p>
                                  <strong className="text-[#EB3465]">Website:</strong>

                                  No Website</p>
                              )}
                            </div>

                            {venue?.type && (
                              <div className="mt-4 text-white flex items-center gap-4 flex-wrap">
                                <h3 className="font-semibold text-[16px] text-[#EB3465]">Type:</h3>
                                {venue.type.split(",").map((item, idx) => (
                                  <span key={idx} className="uppercase text-[14px] flex items-center">
                                    🔹 {item.trim()}
                                  </span>
                                ))}
                              </div>
                            )}


                            {/* Opening Hours */}
                            {Array.isArray(venue?.openingHours) && venue?.openingHours?.length > 0 && (
                              <div className="mt-4 text-white">
                                <h3 className="font-semibold text-[16px] mb-2 text-[#EB3465]">Opening Hours:</h3>
                                <ul className="text-[14px]">
                                  {venue.openingHours.map((time, idx) => (
                                    <li key={idx} className="flex items-center gap-2">
                                      🕒 {time}
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}


                          </div>
                        </div>
                      ))}

                  </div>

                  {/* Booking Button */}
                  <div className="flex flex-col justify-center items-center mt-[30px]">
                    <Link
                      to={selectedVenues.length > 0 ? `/payment-book` : "#"}
                      className={`mt-4 px-[50px] py-[17px] font-[500] text-[18px] rounded transition duration-300 bg-[#ff0062] text-white hover:bg-[#4400c3] ${selectedVenues.length > 0
                        ? "cursor-pointer"
                        : "cursor-not-allowed"
                        }`}
                      onClick={(e) => {
                        dispatch(updateData({ summary: description }));
                        if (selectedVenues.length <= 0) e.preventDefault();
                      }}
                    >
                      Book Now
                    </Link>
                    <Submit steps={1} />
                  </div>
                </>
              ) : (
                <Submit steps={2} />
              )}
            </>
          )}
        </>

      </div>
    </>
  );
}
